var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronUpMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3536 18.9757L23.6465 21.0243L16.5001 15.0689L9.35364 21.0243L7.64648 18.9757L16.5001 11.5977L25.3536 18.9757Z",
    fill: "#222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUpMini);
export default __webpack_public_path__ + "static/media/ChevronUpMini.75c69815c670167b9710e4cfbe617ef5.svg";
export { ForwardRef as ReactComponent };